import React, { PureComponent } from 'react';
import cn from 'classnames';
import { bool } from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { offers } from '../../services/ApiService';

class OfferRequestModal extends PureComponent {
  static propTypes = {
    open: bool.isRequired,
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      data: {
        name: '',
        description: '',
      },
      errors: {},
      isLoading: false,

      validate: [
        {
          name: 'name',
          validation: 'isRequired',
        },
      ],
    };
  }

  validate = () => {
    const { data, validate } = this.state;
    const errors = {};

    validate.forEach((field) => {
      if (field.validation === 'isRequired') {
        if (data[field.name].length < 3) {
          errors[field.name] = 'required';
        }
      }
    });

    return errors;
  };

  handleChange = ({ target }) => {
    const { name, value } = target;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [name]: value,
      },
    }));
  };

  handleKeyDown = (e) => {
    // запрещаем ввод "+", "-", "e"
    if ([107, 109, 69].includes(e.keyCode)) {
      e.preventDefault();
    }
  };

  handleSubmit = () => {
    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState(() => ({
        errors,
      }));
    } else {
      const { data } = this.state;
      this.setState(() => ({
        isLoading: true,
      }));

      offers
        .sendOfferRequest(data)
        .then((response) => {
          const { intl } = this.props;

          this.setState(() => ({
            data: {
              name: '',
              description: '',
            },
            errors: {},
            isLoading: false,
          }));

          const alertText = intl.formatMessage({
            id: 'offer.request-form.success',
            defaultMessage:
              'Your request has been successfully submitted. We will notify you after we will add the offer',
          });

          this.props.showAlert({
            alertType: 'success',
            dismissable: true,
            message: alertText,
          });

          this.props.toggle();
        })
        .catch((err) => {
          if (err) {
            const { data } = err.response;
            if (data && data.error) {
              const { message } = data.error;

              if (message) {
                this.setState(() => ({
                  errors: {
                    response: message.message,
                  },
                  isLoading: false,
                }));
              }
            }
          }
        });
    }
  };

  getIntlString = ({ id, defaultMessage }) => {
    const { intl } = this.props;
    return intl.formatMessage({
      id,
      defaultMessage,
    });
  };

  render() {
    const { open, toggle } = this.props;
    const { errors, isLoading } = this.state;

    return (
      <Modal
        backdrop="static"
        toggle={toggle}
        isOpen={open}
        centered
        autoFocus
        className="modal-lg offer-request-modal"
      >
        <ModalHeader toggle={toggle}>
          <FormattedMessage
            id="offer.request-form.title"
            defaultMessage="Request for a new offer"
          />
        </ModalHeader>

        <ModalBody>
          <Form onSubmit={(e) => e.preventDefault()}>
            {errors.response && <small className="form-text inline-error">{errors.response}</small>}

            <div>
              <FormGroup className={cn('form-group-upper-label', { 'has-error': errors.name })}>
                <Label for="name">
                  <FormattedMessage
                    id="offer.request-form.name"
                    defaultMessage="Title of the offer"
                  />
                </Label>
                <Input id="name" name="name" onChange={this.handleChange} required />
                {errors.name && <small className="form-text">{errors.name}</small>}
              </FormGroup>

              <FormGroup
                className={cn('form-group-upper-label', { 'has-error': errors.description })}
              >
                <Label for="description">
                  <FormattedMessage
                    id="offer.request-form.description"
                    defaultMessage="Description"
                  />
                </Label>
                <Input id="description" name="description" onChange={this.handleChange} required />
                {errors.description && <small className="form-text">{errors.description}</small>}
              </FormGroup>
            </div>
          </Form>
        </ModalBody>

        <ModalFooter>
          <Button type="button" color="secondary" onClick={toggle}>
            Отмена
          </Button>
          <Button type="button" color="primary" onClick={this.handleSubmit} disabled={isLoading}>
            <FormattedMessage id="offer.request-form.submit" defaultMessage="Add the offer" />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default injectIntl(OfferRequestModal);
